module.exports = __webpack_public_path__ + "static/img/international_model_pc.335cc33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/international_model_pc.png
// module id = oVzV
// module chunks = 34